


















































































































import { Component, Vue } from 'vue-property-decorator';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';
import Player from '../../../components/vui-luma/Course/Player.vue';
import LessonNavbar from '../../../components/vui-luma/Course/LessonNavbar.vue';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import {readComments, readLesson} from '@/store/courses/getters';
import {
  dispatchAddComment,
  dispatchGetLesson, dispatchGetLessonComments,
  dispatchSetViewLesson,
} from '@/store/courses/actions';
import PageHeadline from '../../../components/vui-luma/Ui/PageHeadline.vue';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';

@Component({
  components: {
    MdIcon,
    Player,
    LessonNavbar,
      PageSeparator,
      PageHeadline,
  },
})
export default class LessonView extends Vue {
  public containerClass = '';
  public commentBody = '';
  public videoPlayer: any = null;

  public async mounted() {
    await dispatchGetLesson(this.$store, {lessonId: this.$router.currentRoute.params.id});
    if (!this.lesson) {
      this.$router.push('/lessons');
      return;
    }
    await dispatchGetLessonComments(this.$store, {lessonId: this.$router.currentRoute.params.id});
    setTimeout(async () => {await this.updateViewedTime(this.$router.currentRoute.params.id); }, 10000);
    if (this.$refs.player) {
      this.videoPlayer = videojs(
        // @ts-ignore
        this.$refs.player.$el, {
          controls: true,
          fluid: true,
          preload: 'auto',
          sources: [{
            type: "video/mp4",
            src: this.lesson.video_mp4_link
          },{
            type: "video/webm",
            src: this.lesson.video_webm_link
          },{
            type: "video/ogg",
            src: this.lesson.video_ogv_link
          }],
        },
        () => {
          // @ts-ignore
          console.log('PlayerReady');
        }
      );
    }
    if (this.$refs.player && this.lesson && this.lesson.view_time > 0) {
      // @ts-ignore
      this.$refs.player.$el.currentTime = this.lesson.view_time;
    }
  }

  get lesson() {
    return readLesson(this.$store);
  }

  get comments() {
    return readComments(this.$store);
  }

  public async submitComment() {
    if (this.commentBody !== '') {
      const data = {
        comment: this.commentBody,
        lesson: this.$router.currentRoute.params.id,
      };
      await dispatchAddComment(this.$store, data);
      this.commentBody = '';
    }
  }

  public async updateViewedTime(id) {
    if (this.$router.currentRoute.path === `/lesson/view/${id}`) {
      if (this.$refs.player) {
        // @ts-ignore
        await dispatchSetViewLesson(this.$store, {lessonId: id, time: this.$refs.player.$el.currentTime});
      }
      setTimeout(async () => {await this.updateViewedTime(id); }, 10000);
    }
  }

}
